import { useEffect } from "react";
import { DOMAIN, BIZ_FULL, CTA_URL } from "../data/site";

const setMeta = (attr, key, val) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", val);
};
const setLink = (rel, href, type) => {
  const sel = type ? `link[rel="${rel}"][type="${type}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!href) { if (el) el.remove(); return; }
  if (!el) { el = document.createElement("link"); el.rel = rel; if (type) el.type = type; document.head.appendChild(el); }
  el.href = href;
};

const baseGraph = [
  { "@type": "WebSite", "@id": `${DOMAIN}/#website`, url: `${DOMAIN}/`, name: BIZ_FULL, inLanguage: "en-US", publisher: { "@id": `${DOMAIN}/#publisher` } },
  { "@type": "Organization", "@id": `${DOMAIN}/#publisher`, name: "Fat Wallet Internet Marketing", url: CTA_URL, brand: { "@type": "Brand", name: "VisibilityReady" } },
];

export const Seo = ({ title, description, path, crumbs = [], extra = [], md, image = "hero-burners-1280.webp", type = "WebPage" }) => {
  useEffect(() => {
    const url = `${DOMAIN}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", `${DOMAIN}/assets/images/${image}`);
    setMeta("name", "twitter:card", "summary_large_image");
    setLink("canonical", url);
    setLink("alternate", md ? `${DOMAIN}${md}` : null, "text/markdown");
    const graph = [
      ...baseGraph,
      { "@type": type, "@id": `${url}#webpage`, url, name: title, description, isPartOf: { "@id": `${DOMAIN}/#website` }, inLanguage: "en-US" },
      ...(crumbs.length ? [{ "@type": "BreadcrumbList", itemListElement: crumbs.map((c, i) => ({ "@type": "ListItem", position: i + 1, name: c.label, item: `${DOMAIN}${c.to || path}` })) }] : []),
      ...extra,
    ];
    let s = document.getElementById("ld-json");
    if (!s) { s = document.createElement("script"); s.id = "ld-json"; s.type = "application/ld+json"; document.head.appendChild(s); }
    s.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
  }, [title, description, path, md, image, type, crumbs, extra]);
  return null;
};
